import { DisplayText } from 'src/app/models/events/displayText';
import { CoreEnum } from 'src/app/enums/core.enum';
import { DefaultBooleanChoiceEnum } from '../enums/default-boolean-choice.enum';
import { DefaultBooleanChoiceOrderEnum } from '../enums/default-boolean-choice-order.enum';
import { TranslateEnumService } from 'src/app/services/translate-enum.service';

export class SelectModel {

  readonly FOR_BOOLEAN_TRUE_KEY = true;
  readonly FOR_BOOLEAN_FALSE_KEY = false;
  readonly FOR_BOOLEAN_TRUE_TEXT = CoreEnum.TEXT_YES;
  readonly FOR_BOOLEAN_FALSE_TEXT = CoreEnum.TEXT_NO;

  selected: DisplayText;
  options: DisplayText[];
  opened: boolean;
  disabled: boolean;
  cssClassSelect: string;
  defaultUnknownText: string;

  translateEnumService: TranslateEnumService = new TranslateEnumService();

  constructor() {
    this.selected = new DisplayText(null, null);
    this.options = [];
    this.opened = false;
    this.disabled = false;
    this.cssClassSelect = null;
    this.defaultUnknownText = this.translateEnumService.getUnknown();
  }

  generateSelectForBoolean(defaultChoice: DefaultBooleanChoiceEnum = DefaultBooleanChoiceEnum.FALSE,
                           order: DefaultBooleanChoiceOrderEnum = DefaultBooleanChoiceOrderEnum.TRUE_THEN_FALSE): void {
    const optionTrue = new DisplayText(this.FOR_BOOLEAN_TRUE_KEY, this.FOR_BOOLEAN_TRUE_TEXT);
    const optionFALSE = new DisplayText(this.FOR_BOOLEAN_FALSE_KEY, this.FOR_BOOLEAN_FALSE_TEXT);
    if (order === DefaultBooleanChoiceOrderEnum.TRUE_THEN_FALSE) {
      this.options.push(optionTrue);
      this.options.push(optionFALSE);
    } else {
      this.options.push(optionFALSE);
      this.options.push(optionTrue);
    }

    if (defaultChoice === DefaultBooleanChoiceEnum.TRUE) {
      this.selected = optionTrue;
    } else {
      this.selected = optionFALSE;
    }
  }

  setSelectedByKey(key: string | boolean): void {
    const option = this.options.find(o => o.key === key);
    if (option) {
      this.selected = option;
    } else {
      this.setUnknownOption();
    }
  }

  setUnknownOption(value?: string): void {
    const text = value ? value : this.translateEnumService.getUnknown();
    this.selected = new DisplayText(null, text);
  }
}
